import React from "react";
import backgroundLandingImg from "../../../../assets/background-landing.png";

const BlogNavHeader = () => {
  return (
    <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat pt-16 pb-8 md:pt-20 md:pb-10 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[280px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none"></div>

      {/* Content */}
      <div className="relative max-w-[720px] mx-auto mt-[10px]">
        <div className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase text-white leading-[50px] pt-[10px] leading-[32px] sm:leading-[40px] md:leading-[50px]">
          recent articles and blogs
        </div>

        <p className="text-white text-[15px] md:text-[19px] leading-relaxed font-normal max-w-[600px] mx-auto mt-[15px]">
          the latest industry news, interviews, technologies, and resources.
        </p>
      </div>
    </section>
  );
};

export default BlogNavHeader;
